import { render, staticRenderFns } from "./GunBox.vue?vue&type=template&id=4c41d7a8&"
import script from "./GunBox.vue?vue&type=script&lang=ts&"
export * from "./GunBox.vue?vue&type=script&lang=ts&"
import style0 from "./GunBox.vue?vue&type=style&index=0&id=4c41d7a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports